// Deliberately loose shape check (something@something.tld, no spaces) —
// the same regex the BE uses (app/warehouse/components/email.js). The real
// validation is the delivery attempt; this only catches obvious typos.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (value: string): boolean =>
    typeof value === "string" && value.length <= 254 && EMAIL_RE.test(value.trim());
